module.exports = __webpack_public_path__ + "img/alojamiento.d7f42024.png";